// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"282":"75b1e353","340":"f5b93c59","484":"b78a082b","790":"6287bf0a","881":"db653e2f","970":"cdf6132b"}[chunkId] + ".chunk.css";
};